import * as React from "react";
import * as ReactDOM from "react-dom";
import { Modal } from "antd";

const IS_REACT_16 = !!ReactDOM.createPortal;

export default function modal(config: any): any {
  const div = document.createElement("div");
  document.body.appendChild(div);
  const close = (...args: any[]) => {
    if (IS_REACT_16) {
      // @ts-ignore
      render({ ...config, close, visible: false, afterClose: destroy.bind(this, ...args) });
    } else {
      destroy(...args);
    }
  };
  const destroy = (...args: any[]) => {
    const unmountResult = ReactDOM.unmountComponentAtNode(div);
    if (unmountResult && div.parentNode) {
      div.parentNode.removeChild(div);
    }
    const triggerCancel = args && args.length && args.some(param => param && param.triggerCancel);
    if (config.onCancel && triggerCancel) {
      config.onCancel(...args);
    }
  };
  const render = (props: any) => {
    ReactDOM.render(<Modal {...props}>{props.content}</Modal>, div);
  };
  render({ ...config, visible: true, close });
  return {
    destroy: close
  };
}



// WEBPACK FOOTER //
// ./src/pc/component/dialog/modal.tsx